(function($, window, undefined) {
	function LocationPageSlider(args) {
		this.swiper;
		this.defaults = {
			selectors: {
				widgetContainer: "[data-location-slider]",
				swiperContainer: "[data-location-swiper-container]",
			},
		};

		this.options = $.extend(true, {}, this.defaults, args);

		this.$widgetContainer = $(this.options.selectors.widgetContainer);
		this.$swiperContainer = this.parent(this.options.selectors.swiperContainer);

		var breakpoint = window.matchMedia("(min-width:992px)");
		var mySwiper;
		var breakpointChecker = function() {
			if (breakpoint.matches === true) {
				if (mySwiper !== undefined){
					mySwiper.destroy(true, true);
				} else {
					return;
				}
			} else if (breakpoint.matches === false) {
				return enableSwiper();
			}
		};

		var self = this;
		var enableSwiper = function() {
			mySwiper = new Swiper(self.$swiperContainer, {
				init: true,
				spaceBetween: 20,
				centeredSlides: true,
				centeredSlidesBounds: true,
				loop: false,
				slidesOffsetBefore: 15,
				slidesOffsetAfter: 0,
			});
		};

		breakpoint.addListener(breakpointChecker);
		breakpointChecker();
	}

	/**
	 * Returns a jQuery element that is a child of the parent element
	 * @param selector
	 * @returns {*|HTMLElement}
	 */
	LocationPageSlider.prototype.parent = function(selector) {
		return $(selector, this.$widgetContainer);
	};


	window.SVHA = window.SVHA || {};
	window.SVHA.Widgets = window.SVHA.Widgets || {};
	window.SVHA.Widgets.LocationPageSlider = LocationPageSlider;
})(jQuery, window);
